import { Center, Divider, Flex, Link, Text } from "@chakra-ui/react";
import Image from "next/image";
import { ModalDrawer } from "ui";
import immunifi from "../assets/immunifi.svg";
import linkicon from "./link.svg";

type AuditDataType = {
  title: string;
  link?: string;
  logo: any;
};

interface ImageObject {
  src: any;
  alt: string;
}

interface PopUpModalProps {
  isOpen: boolean;
  onClose: () => void;
  image: ImageObject;
  text1: string;
  text2?: string;
  bugbountyLink?: string;
  header: string;
  version?: 1 | 2;
  auditData: AuditDataType[] | undefined;
  onClick?: (data: AuditDataType) => void;
}

export const AuditModal = ({
  isOpen,
  onClose,
  image,
  text1,
  text2,
  header,
  auditData,
  version = 2,
  bugbountyLink,
  onClick,
}: PopUpModalProps) => {
  return (
    <ModalDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerTitle={header}
      showMobileCloseButton
      version={version}
    >
      <Center flexDirection="column">
        <Image src={image.src} alt={image.alt} height={66.67} width={66.67} />
        <Text
          className="p16"
          color="Text_Main"
          mt="20px"
          mb="0"
          fontSize="16px"
        >
          {text1}
        </Text>
        {text2 && (
          <Text className="p16" color="Text_Main" m="0" p="0" fontSize="16px">
            {text2}
          </Text>
        )}
        {auditData && (
          <Flex
            justifyContent="center"
            flexWrap="wrap"
            my="12px"
            gap="8px"
            w="100%"
          >
            {auditData.map((ad: AuditDataType, index: number) => {
              return (
                <Link
                  key={`audit${index}`}
                  onClick={() => onClick && onClick(ad)}
                  bg="Base_Canvas_Bg"
                  height="52px"
                  p="16px"
                  maxWidth="calc(50% - 8px)"
                  width="100%"
                  my="4px"
                  borderRadius="8px"
                  href={ad?.link}
                  isExternal
                  _hover={{
                    textDecoration: "none",
                  }}
                >
                  <Flex justifyContent="space-between">
                    <Flex alignItems="center" justifyContent="space-between">
                      <Image src={ad.logo} alt="link" height={20} width={20} />
                      <Text mx="8px" as="span" fontSize="12px">
                        {ad.title}
                      </Text>
                    </Flex>
                    <Image src={linkicon} alt="link" height={12} width={12} />
                  </Flex>
                </Link>
              );
            })}
          </Flex>
        )}
        {bugbountyLink && (
          <>
            <Divider mt="24px" />

            <Flex mt="24px" mb="16px" flexDir="column" alignItems="center">
              <Text
                className="p16"
                color="Text_Main"
                mt="0"
                mb="0"
                fontSize="16px"
              >
                Report bug and earn bounty
              </Text>
              <Link
                bg="Base_Canvas_Bg"
                height="52px"
                p="16px"
                mt="1rem"
                borderRadius="8px"
                href={bugbountyLink}
                w="80%"
                isExternal
                _hover={{
                  textDecoration: "none",
                }}
              >
                <Flex justifyContent="space-between">
                  <Flex alignItems="center">
                    <Image src={immunifi} alt="link" height={20} width={20} />
                    <Text ml="8px" as="span" fontSize="12px">
                      Immunefi
                    </Text>
                  </Flex>
                  <Image src={linkicon} alt="link" height={12} width={12} />
                </Flex>
              </Link>
            </Flex>
          </>
        )}
      </Center>
    </ModalDrawer>
  );
};
